import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const addCategoryFunc = createAsyncThunk(
    "addCategory",
    async ({ data }, thunkAPI) => {
        try {            
            const res = await api.post(`dashboard/categories`, data);
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || { message: error.message });
        }
    }
)
const addCategorySlicer = createSlice({
    name: "addCategory",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(addCategoryFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
        .addCase(addCategoryFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";
            })
        .addCase(addCategoryFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
});
export default addCategorySlicer.reducer;